import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import { LoadingSpinner, Header } from '@components/Generic'
import { StoreContext } from '@store/Root.store'
import { devLog } from '@methods/devLog'
import { axiosInstance } from '@methods/axiosConfig'
import { forceRedirect } from '@methods/forceRedirect'
import { useInterval } from 'usehooks-ts'
import { usePageVisibility } from '@/hooks/usePageVisibility'
import { API_URL, ONBOARDING_SERVICE_PATH } from '@constants/apiUrl'

interface PollingResponse {
  status: string
  shouldWait: boolean
  location?: string
}

export const WaitingAfterGoToMobilePage = observer(() => {
  const store = useContext(StoreContext)
  const { switchToMobile: trans } = store.TranslationsState.translationsNew

  const [shouldWait, setShouldWait] = useState(true)
  const [shouldPoll, setShouldPoll] = useState(true)

  const isVisible = usePageVisibility()

  const checkStatus = async (): Promise<PollingResponse | undefined> => {
    try {
      const res = await axiosInstance.get<PollingResponse>(
        `${API_URL}/${ONBOARDING_SERVICE_PATH}/waiting-till-end`,
        { withCredentials: true }
      )

      if (!res.data.shouldWait && res.data.location) {
        setShouldWait(false)
        forceRedirect(res.data.location)
      }

      return res.data
    } catch (e) {
      devLog(e)
    }
  }

  useEffect(() => {
    setShouldPoll(isVisible)
  }, [isVisible])

  useEffect(() => {
    shouldWait && shouldPoll && checkStatus()
  }, [shouldWait, shouldPoll])

  useInterval(checkStatus, shouldWait && shouldPoll ? 3000 : null)

  return (
    <div className="page-container mobile-m-0">
      <Header className="m-30-0">{trans.waitingForMobile.header}</Header>

      <div className="generic__go-to-mobile__warning-line">
        {trans.waitingForMobile.description}
      </div>

      <LoadingSpinner />
    </div>
  )
})
